import { FC, useMemo, useCallback } from 'react'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import { confirmMixedAccountOperationActionCreator } from 'actions/linkageActions'
import { MixedAccountsTableItem } from 'selectors/linkageSelectors'

type AccountActionUnlinkHandlerProps = {
  accountInfo: MixedAccountsTableItem
}

export const AccountActionUnlinkHandler: FC<AccountActionUnlinkHandlerProps> = (props) => {
  const { accountInfo, children } = props
  const { account, providerAccount, type } = accountInfo
  const { link_status = false } = account || {}

  const dispatch = useStoreDispatch()

  const handleClick = useCallback(() => {
    const currentAccount = type === 'manual'
      ? account
      : account || providerAccount

    if (!currentAccount) {
      return
    }

    dispatch(confirmMixedAccountOperationActionCreator(currentAccount, 'unlink'))
  }, [dispatch, account, providerAccount, type])

  const isExist = useMemo(() => {
    return link_status === 'active'
  }, [link_status])

  if (!isExist) {
    return null
  }

  return (
    <div onClick={ handleClick }>
      { children }
    </div>
  )
}
